import {
  FlagAD,
  FlagAE,
  FlagAF,
  FlagAG,
  FlagAI,
  FlagAL,
  FlagAM,
  FlagAO,
  FlagAQ,
  FlagAR,
  FlagAS,
  FlagAT,
  FlagAU,
  FlagAW,
  FlagAX,
  FlagAZ,
  FlagBA,
  FlagBB,
  FlagBQ,
  FlagBD,
  FlagBE,
  FlagBF,
  FlagBG,
  FlagBH,
  FlagBI,
  FlagBJ,
  FlagBL,
  FlagBM,
  FlagBN,
  FlagBO,
  FlagBQBO,
  FlagBQSA,
  FlagBQSE,
  FlagBR,
  FlagBS,
  FlagBT,
  FlagBV,
  FlagBW,
  FlagBY,
  FlagBZ,
  FlagCA,
  FlagCC,
  FlagCD,
  FlagCF,
  FlagCG,
  FlagCH,
  FlagCI,
  FlagCK,
  FlagCL,
  FlagCM,
  FlagCN,
  FlagCO,
  FlagCR,
  FlagCU,
  FlagCV,
  FlagCW,
  FlagCX,
  FlagCY,
  FlagCZ,
  FlagDE,
  FlagDJ,
  FlagDK,
  FlagDM,
  FlagDO,
  FlagDZ,
  FlagEC,
  FlagEE,
  FlagEG,
  FlagEH,
  FlagER,
  FlagES,
  FlagET,
  FlagFI,
  FlagFJ,
  FlagFK,
  FlagFM,
  FlagFO,
  FlagFR,
  FlagGA,
  FlagGBSCT,
  FlagGBUKM,
  FlagGBWLS,
  FlagGBNIR,
  FlagGD,
  FlagGE,
  FlagGF,
  FlagGG,
  FlagGH,
  FlagGI,
  FlagGL,
  FlagGM,
  FlagGN,
  FlagGP,
  FlagGQ,
  FlagGR,
  FlagGS,
  FlagGT,
  FlagGU,
  FlagGW,
  FlagGY,
  FlagHK,
  FlagHN,
  FlagHM,
  FlagHR,
  FlagHT,
  FlagHU,
  FlagID,
  FlagIE,
  FlagIL,
  FlagIM,
  FlagIN,
  FlagIO,
  FlagIQ,
  FlagIR,
  FlagIS,
  FlagIT,
  FlagJE,
  FlagJM,
  FlagJO,
  FlagJP,
  FlagKE,
  FlagKG,
  FlagKH,
  FlagKI,
  FlagKM,
  FlagKN,
  FlagKP,
  FlagKR,
  FlagKW,
  FlagKY,
  FlagKZ,
  FlagLA,
  FlagLB,
  FlagLC,
  FlagLI,
  FlagLK,
  FlagLR,
  FlagLS,
  FlagLT,
  FlagLU,
  FlagLV,
  FlagLY,
  FlagMA,
  FlagMC,
  FlagMD,
  FlagME,
  FlagMF,
  FlagMG,
  FlagMH,
  FlagMK,
  FlagML,
  FlagMM,
  FlagMN,
  FlagMO,
  FlagMP,
  FlagMQ,
  FlagMR,
  FlagMS,
  FlagMT,
  FlagMU,
  FlagMV,
  FlagMW,
  FlagMX,
  FlagMY,
  FlagMZ,
  FlagNA,
  FlagNC,
  FlagNE,
  FlagNF,
  FlagNG,
  FlagNI,
  FlagNL,
  FlagNO,
  FlagNP,
  FlagNR,
  FlagNU,
  FlagNZ,
  FlagOM,
  FlagPA,
  FlagPE,
  FlagPF,
  FlagPG,
  FlagPH,
  FlagPK,
  FlagPL,
  FlagPM,
  FlagPN,
  FlagPR,
  FlagPS,
  FlagPT,
  FlagPW,
  FlagPY,
  FlagQA,
  FlagRE,
  FlagRO,
  FlagRS,
  FlagRU,
  FlagRW,
  FlagSA,
  FlagSB,
  FlagSC,
  FlagSD,
  FlagSE,
  FlagSG,
  FlagSH,
  FlagSJ,
  FlagSI,
  FlagSK,
  FlagSL,
  FlagSM,
  FlagSN,
  FlagSO,
  FlagSR,
  FlagSS,
  FlagST,
  FlagSV,
  FlagSX,
  FlagSY,
  FlagSZ,
  FlagTC,
  FlagTD,
  FlagTF,
  FlagTG,
  FlagTH,
  FlagTJ,
  FlagTK,
  FlagTL,
  FlagTM,
  FlagTN,
  FlagTO,
  FlagTR,
  FlagTT,
  FlagTV,
  FlagTW,
  FlagTZ,
  FlagUA,
  FlagUG,
  FlagUM,
  FlagUS,
  FlagUY,
  FlagUZ,
  FlagVA,
  FlagVC,
  FlagVE,
  FlagVG,
  FlagVI,
  FlagVN,
  FlagVU,
  FlagWF,
  FlagWS,
  FlagYE,
  FlagYT,
  FlagZA,
  FlagZM,
  FlagZW
} from '@adara-cs/icons'

const icons = {
  AD: FlagAD,
  AE: FlagAE,
  AF: FlagAF,
  AG: FlagAG,
  AI: FlagAI,
  AL: FlagAL,
  AM: FlagAM,
  AO: FlagAO,
  AQ: FlagAQ,
  AR: FlagAR,
  AS: FlagAS,
  AT: FlagAT,
  AU: FlagAU,
  AW: FlagAW,
  AX: FlagAX,
  AZ: FlagAZ,
  BA: FlagBA,
  BB: FlagBB,
  BQ: FlagBQ,
  BD: FlagBD,
  BE: FlagBE,
  BF: FlagBF,
  BG: FlagBG,
  BH: FlagBH,
  BI: FlagBI,
  BJ: FlagBJ,
  BL: FlagBL,
  BM: FlagBM,
  BN: FlagBN,
  BO: FlagBO,
  BQBO: FlagBQBO,
  BQSA: FlagBQSA,
  BQSE: FlagBQSE,
  BR: FlagBR,
  BS: FlagBS,
  BT: FlagBT,
  BV: FlagBV,
  BW: FlagBW,
  BY: FlagBY,
  BZ: FlagBZ,
  CA: FlagCA,
  CC: FlagCC,
  CD: FlagCD,
  CF: FlagCF,
  CG: FlagCG,
  CH: FlagCH,
  CI: FlagCI,
  CK: FlagCK,
  CL: FlagCL,
  CM: FlagCM,
  CN: FlagCN,
  CO: FlagCO,
  CR: FlagCR,
  CU: FlagCU,
  CV: FlagCV,
  CW: FlagCW,
  CX: FlagCX,
  CY: FlagCY,
  CZ: FlagCZ,
  DE: FlagDE,
  DJ: FlagDJ,
  DK: FlagDK,
  DM: FlagDM,
  DO: FlagDO,
  DZ: FlagDZ,
  EC: FlagEC,
  EE: FlagEE,
  EG: FlagEG,
  EH: FlagEH,
  ER: FlagER,
  ES: FlagES,
  ET: FlagET,
  FI: FlagFI,
  FJ: FlagFJ,
  FK: FlagFK,
  FM: FlagFM,
  FO: FlagFO,
  FR: FlagFR,
  GA: FlagGA,
  GB: FlagGBUKM,
  GBSCT: FlagGBSCT,
  GBUKM: FlagGBUKM,
  GBWLS: FlagGBWLS,
  GBNIR: FlagGBNIR,
  GD: FlagGD,
  GE: FlagGE,
  GF: FlagGF,
  GG: FlagGG,
  GH: FlagGH,
  GI: FlagGI,
  GL: FlagGL,
  GM: FlagGM,
  GN: FlagGN,
  GP: FlagGP,
  GQ: FlagGQ,
  GR: FlagGR,
  GS: FlagGS,
  GT: FlagGT,
  GU: FlagGU,
  GW: FlagGW,
  GY: FlagGY,
  HK: FlagHK,
  HN: FlagHN,
  HM: FlagHM,
  HR: FlagHR,
  HT: FlagHT,
  HU: FlagHU,
  ID: FlagID,
  IE: FlagIE,
  IL: FlagIL,
  IM: FlagIM,
  IN: FlagIN,
  IO: FlagIO,
  IQ: FlagIQ,
  IR: FlagIR,
  IS: FlagIS,
  IT: FlagIT,
  JE: FlagJE,
  JM: FlagJM,
  JO: FlagJO,
  JP: FlagJP,
  KE: FlagKE,
  KG: FlagKG,
  KH: FlagKH,
  KI: FlagKI,
  KM: FlagKM,
  KN: FlagKN,
  KP: FlagKP,
  KR: FlagKR,
  KW: FlagKW,
  KY: FlagKY,
  KZ: FlagKZ,
  LA: FlagLA,
  LB: FlagLB,
  LC: FlagLC,
  LI: FlagLI,
  LK: FlagLK,
  LR: FlagLR,
  LS: FlagLS,
  LT: FlagLT,
  LU: FlagLU,
  LV: FlagLV,
  LY: FlagLY,
  MA: FlagMA,
  MC: FlagMC,
  MD: FlagMD,
  ME: FlagME,
  MF: FlagMF,
  MG: FlagMG,
  MH: FlagMH,
  MK: FlagMK,
  ML: FlagML,
  MM: FlagMM,
  MN: FlagMN,
  MO: FlagMO,
  MP: FlagMP,
  MQ: FlagMQ,
  MR: FlagMR,
  MS: FlagMS,
  MT: FlagMT,
  MU: FlagMU,
  MV: FlagMV,
  MW: FlagMW,
  MX: FlagMX,
  MY: FlagMY,
  MZ: FlagMZ,
  NA: FlagNA,
  NC: FlagNC,
  NE: FlagNE,
  NF: FlagNF,
  NG: FlagNG,
  NI: FlagNI,
  NL: FlagNL,
  NO: FlagNO,
  NP: FlagNP,
  NR: FlagNR,
  NU: FlagNU,
  NZ: FlagNZ,
  OM: FlagOM,
  PA: FlagPA,
  PE: FlagPE,
  PF: FlagPF,
  PG: FlagPG,
  PH: FlagPH,
  PK: FlagPK,
  PL: FlagPL,
  PM: FlagPM,
  PN: FlagPN,
  PR: FlagPR,
  PS: FlagPS,
  PT: FlagPT,
  PW: FlagPW,
  PY: FlagPY,
  QA: FlagQA,
  RE: FlagRE,
  RO: FlagRO,
  RS: FlagRS,
  RU: FlagRU,
  RW: FlagRW,
  SA: FlagSA,
  SB: FlagSB,
  SC: FlagSC,
  SD: FlagSD,
  SE: FlagSE,
  SG: FlagSG,
  SH: FlagSH,
  SJ: FlagSJ,
  SI: FlagSI,
  SK: FlagSK,
  SL: FlagSL,
  SM: FlagSM,
  SN: FlagSN,
  SO: FlagSO,
  SR: FlagSR,
  SS: FlagSS,
  ST: FlagST,
  SV: FlagSV,
  SX: FlagSX,
  SY: FlagSY,
  SZ: FlagSZ,
  TC: FlagTC,
  TD: FlagTD,
  TF: FlagTF,
  TG: FlagTG,
  TH: FlagTH,
  TJ: FlagTJ,
  TK: FlagTK,
  TL: FlagTL,
  TM: FlagTM,
  TN: FlagTN,
  TO: FlagTO,
  TR: FlagTR,
  TT: FlagTT,
  TV: FlagTV,
  TW: FlagTW,
  TZ: FlagTZ,
  UA: FlagUA,
  UG: FlagUG,
  UM: FlagUM,
  US: FlagUS,
  UY: FlagUY,
  UZ: FlagUZ,
  VA: FlagVA,
  VC: FlagVC,
  VE: FlagVE,
  VG: FlagVG,
  VI: FlagVI,
  VN: FlagVN,
  VU: FlagVU,
  WF: FlagWF,
  WS: FlagWS,
  YE: FlagYE,
  YT: FlagYT,
  ZA: FlagZA,
  ZM: FlagZM,
  ZW: FlagZW,
} as const;

export type FlagIconName = keyof typeof icons

export const getFlagIcon = (name: FlagIconName) => {
  return icons[name]
}
